<template>
  <div>
    <list-block>
      <el-form
        ref="formData"
        :rules="rules"
        :inline="true"
        :model="formData"
      >
        <h4 style="margin-bottom: 10px;">
          节点通用设置
        </h4>
        <el-row>
          <el-col :span="9">
            <el-form-item
              label="是否自动填充固定路线："
              prop="autoFillFixLineCode"
            >
              <el-radio-group
                v-model="formData.autoFillFixLineCode"
                :disabled="isDetail"
              >
                <el-radio
                  v-for="item in useTransportationInventory"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否可预占在途库存：" prop="useTransportationInventory">
              <el-radio-group
                v-model="formData.useTransportationInventory"
                disabled
              >
                <el-radio
                  v-for="item in useTransportationInventory"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <prescription
              :time.sync="formData.executeMaxTime"
              :time-type.sync="formData.timeUnit"
              :disabled="isDetail"
            />
          </el-col>
        </el-row>
        <TaskSetting
          ref="taskTableEl"
          :node-index="0"
          :table-data="formData.ruleFlowTaskItemDetails"
        />
      </el-form>
    </list-block>
  </div>
</template>

<script>
import ListBlock from '@/components/ListBlock/index.vue';
import Prescription from '../../components/Prescription.vue';
import TaskSetting from './TaskSetting.vue';
import { enableShutdownState, useTransportationInventory, NODE_TYPE } from './constant';

export default {
  components: {
    ListBlock,
    Prescription,
    TaskSetting,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      useTransportationInventory,
      enableShutdownState,
      rules: {
        useTransportationInventory: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        autoFillFixLineCode: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    // 纯获取数据
    getPureTableData() {
      return this.$refs.taskTableEl.getPureTableData();
    },
    resetTaskOptions() {
      return this.$refs.taskTableEl.resetTaskOptions();
    },
    validateForm() {
      /* eslint-disable-next-line */
      return new Promise(async (resolve) => {
        try {
          await this.$refs.formData.validate();
          const tableData = await this.$refs.taskTableEl.getTableData(0);
          resolve(tableData);
        } catch (error) {
          this.$message.warning(`请完善“${NODE_TYPE[0].label}”节点数据`);
        }
      });
    },
  },
};
</script>
